import { Injectable } from '@angular/core';

import { ProductService } from '@shared/services/product/product.service';
import { combineLatest, Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { BetterBuysService } from './better-buys.service';

@Injectable({
  providedIn: 'root',
})
export class BetterBuysResolverService {
  constructor(
    private betterBuysService: BetterBuysService,
    private productService: ProductService,
  ) {}

  resolve(): any {
    return this.getBetterBuysWithDetails();
  }

  getBetterBuysWithDetails() {
    const productNumbers: number[] = [];
    const betterBuysAreLoaded$ = this.betterBuysService.getBetterBuysLoaded();
    combineLatest([
      betterBuysAreLoaded$,
      this.betterBuysService.getBetterBuys(),
    ])
      .pipe(
        filter(([betterBuysAreLoaded, betterBuys]) => betterBuysAreLoaded),
        take(1),
      )
      .subscribe(([betterBuysAreLoaded, betterBuys]) => {
        betterBuys.forEach(betterBuy => {
          productNumbers.push(
            ...[
              betterBuy.originalProductNumber,
              betterBuy.betterBuyProductNumber,
            ],
          );
        });
      });
    this.productService.loadProductDetails(productNumbers);
    return productNumbers;
  }
}
